// app/javascript/compcalc/components/PDRatings.jsx

import React from "react";
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

import MenuIcon from '@material-ui/icons/Menu';
import EditIcon from '@material-ui/icons/Edit';

import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker as DatePicker } from '@material-ui/pickers';

import moment from "moment";

// import ReactCardFlip from 'react-card-flip';
import ReactCardFlip from './utils/ReactCardFlip';
import TempDisabilityEarningsDialog from './dialogs/TempDisabilityEarningsDialog';

import withErrorHandling from './ErrorHandling';
import SingleSelectionList from './utils/SingleSelectionList';
import ItemArrayList from './utils/ItemArrayList';
import ButtonFlip from './utils/ButtonFlip';
import { currencyFormatter, formatShortDate, isValidDate, toDate, setTimer, saveAsFile, sendMail } from '../utils'
import { combineRatings, getRatingsString } from '../rating_utils'


const styles = theme => ({
  root: {
    // flexGrow: 1,
    marginTop: theme.spacing(1),
  },
  marginBottom: {
    marginBottom: theme.spacing(1),
  },
  inputLabel: {
    fontSize: 22,
    // fontWeight: 'bold',
    // marginBottom: 1*theme.spacing(1), // TODO: margin not working.
  },
  dateField: {
    width: 150,
  },
  searchField: {
    width: 230,
  },
  group: {
    display: 'flex',
    flexFlow: 'row nowrap',
  },
  textFieldDense: {
    margin: 0,
  },
  stretch: {
    // background: 'blue',
    // alignSelf: 'stretch',
    width: 'auto',
  },
  noBackFace: {
    backfaceVisibility: 'hidden',
    WebkitBackfaceVisibility: 'hidden',
  	transform: 'scale(1)',
  	WebkitTransform: 'scale(1)',
  },
  alignCenter: {
    // background: 'green',
    textAlign: 'center',
    // display: 'flex',
    // justifyContent: 'center',    // Horizontal align.
    // alignItems: 'center',        // Vertical align.
    // margin: '0',
    // position: 'absolute',
    // top: '50%',
    // transform: 'translateY(-50%)',
  },
  alignLeft: {
    // background: 'blue',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',        // Vertical align.
  },
  alignRight: {
    // background: 'red',
    display: 'flex',
    flexFlow: 'row-reverse nowrap',
    alignItems: 'center',
  },
  margin: {
    margin: theme.spacing(2),
  },
  wrapContent: {
    padding: theme.spacing(2),
    display: 'inline-block',
  },
  wrapContent1: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: 2,
    display: 'inline-block',
  },
  fullWidth: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: 2,
    width: '100%',
    // background: 'gray',
    display: 'inline-block',
  },
  pre: {
    width: '100%',
    maxWidth: '800px',
    whiteSpace: 'pre-wrap',
  }
});


class PDRatings extends React.PureComponent {

  constructor(props) {
    super(props);
    // console.log('PDRatings.constructor()');

    this.itemsWPI = [];
    for (let i = 0; i < 100; ++i) {
      this.itemsWPI.push(
        <MenuItem dense key={'percent' + i} value={i}>{i}%</MenuItem>
      );
    }

    this.itemsApport = [];
    for (let i = 0; i <= 100; ++i) {
      this.itemsApport.push(
        <MenuItem dense key={'percent' + i} value={i}>{i}%</MenuItem>
      );
    }

    this.lastAnimationTime = 0;
    this.pendingStates = [];

    this.flipTables = true;
    this.blockFlip = false;
    this.flipInterval = 1000;

    this.loadingText = 'Loading...';

    this.pdRateMaxText = 'PD Rate (maximum)';
    this.pdRateMinText = 'PD Rate (minimum)';
    this.pdRateText = 'PD Rate';

    this.minDOB = new Date('1900-01-01T12:00');
    this.minDOI = new Date('1996-01-01T12:00');
    this.maxDOI = new Date('2024-12-31T12:00');

    this.unknownRatingString = 'WPI - DFEC - OCC - AGE - ? %PD';

    let initDOB = new Date('1980-01-01T12:00');
    let initDOI = new Date('2015-01-01T12:00');

    this.initialState = {
      dob: initDOB,
      doi: initDOI,

      wpi: 50,
      apport: 100,

      inputAww: false,
      isCombined: true,

      pdRateText: this.pdRateMaxText,
      aww: currencyFormatter.format(0),
      pdRate: currencyFormatter.format(0),

      isManualAww: false,
      awwArray: [],
      awwDialogArray: [],
      isDialogOpen: false,

      bodyFlip: false,
      bodyDetailFlip: false,
      occupationFlip: false,
      industryFlip: false,
      occGroupFlip: false,

      bodyText: this.loadingText,
      body: 0,
      bodies: [],
      bodiesSearch: [],
      bodySearchIndex: 0,
      bodySearchString: '',

      bodyDetailText: this.loadingText,
      bodyDetail: 0,
      bodyDetails: [],
      bodyDetailsSearch: [],
      bodyDetailSearchIndex: 0,
      bodyDetailSearchString: '',

      industryText: this.loadingText,
      industry: 0,
      industries: [],
      industriesSearch: [],
      industrySearchIndex: 0,
      industrySearchString: '',

      occupationText: this.loadingText,
      occupation: 0,
      occupations: [],
      occupationsSearch: [],
      occupationSearchIndex: 0,
      occupationSearchString: '',

      isOccGroup: false,
      occGroupText: this.loadingText,
      occGroup: 0,
      occGroups: [],
      occGroupsSearch: [],
      occGroupSearchIndex: 0,
      occGroupSearchString: '',

      currentRating: 0,
      ratings: [ {} ], // Array of one empty object (empty rating).
      ratingsStrings: [ this.unknownRatingString ],

      combinedValue: 0.00,
      warning: null,
      amount: 0,
    };
    this.state = { ...this.initialState };
  }

  componentDidMount = () => {
    // console.log('PDRatings.componentDidMount()')
    this.props.setChildMenuHandler(this.handleMenu);
    this.fetchBodies();
  }

  componentWillUnmount = () => {
    this.props.setChildMenuHandler(undefined);
  }

  tryToSetState = (state, afterFunc) => {
    let timeLeft = Date.now() - this.lastAnimationTime;
    if (timeLeft >= 0) {
      // console.log('Set state to ', state);
      this.setState(state, () => {
        if (this.needCopy) {
          this.needCopy = false;
          this.handleMenuCopy();
        }
        // console.log('Now state is ', this.state);
        if (afterFunc) { afterFunc(); }
      });
      return true;
    }
    else {
      console.log(`Timeleft: ${timeLeft}`);
      this.pendingStates.push({ state: state, func: afterFunc });
      setTimer(Math.abs(timeLeft), () => {
        this.applyPendingStates();
      });
      return false;
    }
  }

  applyPendingStates = () => {
    let finalState = {}
    let pendingStates = this.pendingStates
    this.pendingStates = []
    for (const { state, func } of pendingStates) {
      finalState = { ...finalState, ...state }; // Merge states giving priority to latest ones.
    }
    this.tryToSetState(finalState, () => {
      for (const { state, func } of pendingStates) {
        if (func)
          func();
      }
    });
  }

  // --------------------- Fetching ---------------------
  fetchBodies = () => {
    let url = 'api/v1/pd_ratings/body_parts.json';
    this.props.fetch(url, results => {
      this.tryToSetState(this.updateBodies(results), () => this.fetchBodyDetails({ body: 0 }, this.fetchIndustries));
    }).catch(e => this.props.showError(e, 'Error obtaining body parts from server', state));
  }

  fetchIndustries = (state) => {
    let url = 'api/v1/pd_ratings/industries.json';
    this.props.fetch(url, results => {
      let newState = { ...state, ...this.updateIndustries(results) };
      // console.log(newState);
      this.tryToSetState(newState, () => this.fetchOccupations({ industry: 0 }, this.fetchOccGroups));
    }).catch(e => this.props.showError(e, 'Error obtaining industries from server', state));
  }

  fetchOccGroups = (state) => {
    let url = 'api/v1/pd_ratings/groups.json';
    this.props.fetch(url, results => {
      let newState = { ...state, ...this.updateGroups(results) };
      // console.log(newState);
      this.tryToSetState(newState, this.calculate);
    }).catch(e => this.props.showError(e, 'Error obtaining occupational groups from server', state));
  }

  fetchBodyDetailsPromise = (state) => {
    return new Promise( (resolve, reject) => {
      let body = this.state.bodies[state.body];
      let url = `api/v1/pd_ratings/body_details.json?bodyPart=${encodeURIComponent(body)}`;

      console.log(url);
      fetch(url).then(this.props.handleErrors).then(response => response.json()).then(this.props.responseErrorCheck).then(result => {
        let newState = { ...state, ...this.updateBodyDetails(result) };
        // console.log(newState);
        resolve(newState);
      }).catch(e => reject(e, state));
    })
  }

  // func should take as parameters: (result, resolve)
  fetchOccupationsPromise = (state) => {
    return new Promise( (resolve, reject) => {
      let industry = this.state.industries[state.industry];
      let url = `api/v1/pd_ratings/occupations.json?industry=${encodeURIComponent(industry)}`;

      console.log(url);
      fetch(url).then(this.props.handleErrors).then(response => response.json()).then(this.props.responseErrorCheck).then(result => {
        let newState = { ...state, ...this.updateOccupations(result) };
        // console.log(newState);
        resolve(newState);
      }).catch(e => reject(e, state));
    })
  }

  fetchBodyDetails = (state, afterFunc) => {
    this.fetchBodyDetailsPromise(state).then(newState => {
      afterFunc(newState);
    }).catch(e => this.props.showError(e, 'Error obtaining body details from server', state));
  }

  fetchOccupations = (state, afterFunc) => {
    this.fetchOccupationsPromise(state).then(newState => {
      afterFunc(newState);
    }).catch(e => this.props.showError(e, 'Error obtaining occupations from server', state));
  }

  // fetchRatings() is called from calculate().
  fetchRatings = (state, afterFunc) => {
    let url = 'api/v1/pd_ratings/ratings.json';
    let body = JSON.stringify(this.state.ratings);
    // console.log('fetchRatings(), sending:', body);

    this.props.fetchPOST(url, body, result => {
      let newState = this.updateRatings(state, result);
      // console.log('fetchRating(), result:', newState);
      afterFunc(newState);
    }).catch(e => this.props.showError(e, 'Error obtaining ratings from server', state));
  }

  // fetchPermDisResult() is called from combine().
  fetchPermDisResult = (state, afterFunc) => {
    let aww = this.state.inputAww || this.state.isManualAww ? currencyFormatter.parse(this.state.aww) : 0.0;
    if (aww == NaN || aww < 0)
      aww = 0;
    let combinedValue = state.combinedValue ? state.combinedValue : this.state.combinedValue;
    let url = `api/v1/permanent_disability.json?disability=${combinedValue}&date=${formatShortDate(this.state.doi)}&aww=${aww}`;

    this.props.fetch(url, result => {
      afterFunc(state, result);
    }).catch(e => this.props.showError(e, 'Error obtaining permanent disability amount from server', state));
  }

  // --------------------- Updating ---------------------
  updateBodies = (result) => {
    let state = {
      bodies: result,
      bodiesSearch: result,
      bodyText: result[0],
    };
    this.initialState = { ...this.initialState, ...state };
    return state;
  }

  updateBodyDetails = (result) => {
    // result -> { bodyPart: "...", bodyDetails: [...] }
    let details = result['bodyDetails'];
    return {
      bodyDetails: details,
      bodyDetailsSearch: details,
      bodyDetail: 0,
      bodyDetailSearchIndex: 0,
      bodyDetailSearchString: '',
      bodyDetailText: details[0][0],
    };
  }

  updateIndustries = (result) => {
    let state = {
      industries: result,
      industriesSearch: result,
      industryText: result[0],
    };
    this.initialState = { ...this.initialState, ...state };
    return state;
  }

  updateOccupations = (result) => {
    // result -> { industry: "Agriculture", occupations: [ ["Beekeeper", 491], ["Cattle Herder", 491], ... ] }.
    let occs = result['occupations'];
    return {
      occupations: occs,
      occupationsSearch: occs,
      occupation: 0,
      occupationSearchIndex: 0,
      occupationSearchString: '',
      occupationText: occs[0][0],
    };
  }

  updateGroups = (result) => {
    let state = {
      occGroups: result,
      occGroupsSearch: result,
      occGroupText: result[0][1], // First group: it's name.
    };
    this.initialState = { ...this.initialState, ...state };
    return state;
  }

  updateRatings = (state, result) => {
    let ratingsStrings = [];
    for (let i = 0; i < result.length; i++)
      ratingsStrings.push(result[i]['ratingString']);

    return {
      ...state,
      ratings: result,
      ratingsStrings: ratingsStrings,
    };
  }

  // --------------------- Selection changed events ---------------------
  onDialogOpen = () => {
    this.setState({
      awwDialogArray: [ ...this.state.awwArray ],
      isDialogOpen: true,
    });
  };

  onDialogChange = (value) => {
    this.setState({
      awwDialogArray: value
    });
  }

  onDialogClose = (save) => {
    let newState = { isDialogOpen: false };
    if (save != 0) {
      let awwArray = [ ...this.state.awwDialogArray ];

      let days = 0.0, sum = 0.0;
      awwArray.forEach(row => {
        delete row.isSelected;
        let start = moment(row.startDate);
        let end = moment(row.endDate);
        days += end.diff(start, 'days') + 1; // Include end date.
        let wage = currencyFormatter.parse(row.wage);
        sum += wage;
      });

      let aww = sum / days * 7.0;
      let pdRate = aww * 2.0/3.0;

      // console.log('Manual AWW:', days, sum, aww);

      newState = {
        ...newState,
        inputAww: false,
        isManualAww: (save == 1) && (awwArray.length > 0),
        awwArray: awwArray,
        aww: currencyFormatter.format(aww),
        pdRate: currencyFormatter.format(pdRate)
      };
    }
    this.setState(newState, () => this.fetchPermDisResult({}, this.showResult));
  };

  onDateOfBirthChanged = (date) => {
    if (!isValidDate(date)) { return; }

    let doi = this.state.doi;
    if (date < this.minDOB)
      date = this.minDOB;
    if (doi < date)
      doi = date;

    // console.log(`onDateOfBirthChanged: ${date} ${this.state.doi}`);
    this.tryToSetState({
      dob: date,
      doi: doi
    }, this.calculate);
  }

  onDateOfInjuryChanged = (date) => {
    if (!isValidDate(date)) { return; }

    if (date < this.state.dob)
      date = this.state.dob;
    if (date < this.minDOI)
      date = this.minDOI;

    // console.log(`onDateOfInjuryChanged: ${this.state.dob} ${date}`);
    this.tryToSetState({
      doi: date
    }, this.calculate);
  }

  onWpiIndexChanged = (index) => {
    if (this.state.wpi == index) { return; }
    this.tryToSetState({
      wpi: index
    }, this.calculate);
  }

  onApportIndexChanged = (index) => {
    if (this.state.apport == index) { return; }
    this.tryToSetState({
      apport: index
    }, this.calculate);
  }

  onBodyIndexChanged = (index) => {
    if (this.state.bodySearchIndex == index) { return; }
    let current = this.state.bodiesSearch[index];
    let realIndex = this.state.bodies.indexOf(current);
    let state = {
      body: realIndex,
      bodySearchIndex: index,
      bodyText: current,
    };
    this.tryToSetState(state, () => this.fetchBodyDetails(state, this.calculate));
  }

  onBodyDetailIndexChanged = (index) => {
    if (this.state.bodyDetailSearchIndex == index) { return; }
    let current = this.state.bodyDetailsSearch[index];
    let realIndex = this.state.bodyDetails.indexOf(current);
    this.tryToSetState({
      bodyDetail: realIndex,
      bodyDetailSearchIndex: index,
      bodyDetailText: current[0],
    }, this.calculate);
  }

  onIndustryIndexChanged = (index) => {
    if (this.state.industrySearchIndex == index) { return; }
    let current = this.state.industriesSearch[index];
    let realIndex = this.state.industries.indexOf(current);
    let state = {
      industry: realIndex,
      industrySearchIndex: index,
      industryText: current,
    };
    this.tryToSetState(state, () => this.fetchOccupations(state, this.calculate));
  }

  onOccupationIndexChanged = (index) => {
    if (this.state.occupationSearchIndex == index) { return; }
    let current = this.state.occupationsSearch[index];
    let realIndex = this.state.occupations.indexOf(current);
    this.tryToSetState({
      occupation: realIndex,
      occupationSearchIndex: index,
      occupationText: current[0],
    }, this.calculate);
  }

  onOccGroupsIndexChanged = (index) => {
    if (this.state.occGroupSearchIndex == index) { return; }
    let current = this.state.occGroupsSearch[index];
    let realIndex = this.state.occGroups.indexOf(current);
    this.tryToSetState({
      occGroup: realIndex,
      occGroupSearchIndex: index,
      occGroupText: current[1],
    }, this.calculate);
  }

  onRatingIndexChanged = (index) => {
    if (this.state.currentRating == index) { return; }
    this.tryToSetState({
      currentRating: index
    }, () => this.populate(false, false));
  }

  onInputAwwChanged = (checked) => {
    if (this.state.inputAww == checked || this.state.isManualAww) { return; }
    this.tryToSetState({
      inputAww: checked
    }, () => this.fetchPermDisResult({}, this.showResult));
  }

  onCombineChanged = (checked) => {
    if (this.state.isCombined == checked) { return; }
    this.tryToSetState({
      isCombined: checked
    }, this.combine);
  }

  onAwwChanged = (value) => {
    if (!this.state.inputAww) return;
    let aww = currencyFormatter.parse(value);
    let pdRate = aww * 2.0/3.0;
    // console.log(`onAwwChanged(): ${aww}`);

    this.tryToSetState({
      aww: currencyFormatter.format(aww)
    }, () => this.fetchPermDisResult({}, this.showResult));
  }

  onPdRateChanged = (value) => {
    if (!this.state.inputAww) return;
    let pdRate = currencyFormatter.parse(value);
    let aww = pdRate * 3.0/2.0;
    // console.log(`onPdRateChanged(): ${pdRate}`);

    this.tryToSetState({
      aww: currencyFormatter.format(aww)
    }, () => this.fetchPermDisResult({}, this.showResult));
  }

  // --------------------- Flips ---------------------
  onFlip = (name) => {
    if (this.flipTables && !this.blockFlip) {
      let lastTime = Date.now() + this.flipInterval;
      this.setState({ [name]: !this.state[name] }, () => {
        // console.log(`Setting lastAnimationTime to ${this.flipInterval}`);
        this.lastAnimationTime = lastTime;
      });
    }
  }

  onBodyFlip = () => this.onFlip('bodyFlip');
  onBodyDetailFlip = () => this.onFlip('bodyDetailFlip');
  onIndustryFlip = () => this.onFlip('industryFlip');
  onOccupationFlip = () => this.onFlip('occupationFlip');
  onOccGroupFlip = () => this.onFlip('occGroupFlip');

  // --------------------- Search changed ---------------------
  onBodySearchChanged = (e) => {
    let search = e.target.value;
    if (this.state.bodies.length === 0) return;
    // this.state.bodies = [ ..., "15 - Spine", ...]
    let searchLower = search.toLowerCase();
    let current = this.state.bodies[this.state.body];
    let filtered = this.state.bodies.filter( (item) => item.toLowerCase().indexOf(searchLower) >= 0 );
    let indexFiltered = filtered.indexOf(current);

    this.tryToSetState({
      bodiesSearch: filtered,
      bodySearchIndex: indexFiltered,
      bodySearchString: search,
    });
  }

  onBodyDetailSearchChanged = (e) => {
    let search = e.target.value;
    if (this.state.bodyDetails.length === 0) return;
    // this.state.bodyDetails = [ "08 - Skin", [ [["Disfigurement", "08.01.00.00", 2], ...] ].
    let searchLower = search.toLowerCase();
    let current = this.state.bodyDetails[this.state.bodyDetail];
    let filtered = this.state.bodyDetails.filter( (item) => item[0].toLowerCase().indexOf(searchLower) >= 0 );
    let indexFiltered = filtered.indexOf(current);

    this.tryToSetState({
      bodyDetailsSearch: filtered,
      bodyDetailSearchIndex: indexFiltered,
      bodyDetailSearchString: search,
    });
  }

  onIndustrySearchChanged = (e) => {
    let search = e.target.value;
    if (this.state.industries.length === 0) { return; }
    // this.state.industries = [ "All", ... ].
    let searchLower = search.toLowerCase();
    let current = this.state.industries[this.state.industry];
    let filtered = this.state.industries.filter( (item) => item.toLowerCase().indexOf(searchLower) >= 0 );
    let indexFiltered = filtered.indexOf(current);

    this.tryToSetState({
      industriesSearch: filtered,
      industrySearchIndex: indexFiltered,
      industrySearchString: search,
    });
  }

  onOccupationSearchChanged = (e) => {
    let search = e.target.value;
    if (this.state.occupations.length === 0) { return; }
    // this.state.occupations = [ ["Beekeeper", 491], ["Cattle Herder", 491], ... ].
    let searchLower = search.toLowerCase();
    let current = this.state.occupations[this.state.occupation];
    let filtered = this.state.occupations.filter( (item) => item[0].toLowerCase().indexOf(searchLower) >= 0 );
    let indexFiltered = filtered.indexOf(current);

    this.tryToSetState({
      occupationsSearch: filtered,
      occupationSearchIndex: indexFiltered,
      occupationSearchString: search,
    });
  }

  onOccGroupsSearchChanged = (e) => {
    let search = e.target.value;
    if (this.state.occGroups.length === 0) { return; }
    // this.state.occGroups = [ [110, "Group 110: Professional Occupations", "Some use of keyboards... Typical occupations: ..."], ... ].
    let searchLower = search.toLowerCase();
    let current = this.state.occGroups[this.state.occGroup];
    let filtered = this.state.occGroups.filter( (item) => item[1].toLowerCase().indexOf(searchLower) >= 0 ||
                                                          item[2].toLowerCase().indexOf(searchLower) >= 0 );
    let indexFiltered = filtered.indexOf(current);

    this.tryToSetState({
      occGroupsSearch: filtered,
      occGroupSearchIndex: indexFiltered,
      occGroupSearchString: search,
    });
  }

  // --------------------- Menu functions ---------------------
  handleMenu = (menu, submenu, parameter) => {
    // console.log(`handleMenu: menu = ${menu}, submenu = ${submenu}, parameter = ${parameter}`);
    switch (submenu) {
      case 'save':
        this.handleMenuSave();
        break;
      case 'load':
        this.handleMenuLoad();
        break;
      case 'pdf':
        this.handleMenuPdf();
        break;
        case 'mail':
        this.handleMenuMail();
        break;
      case 'add':
        this.handleMenuAdd();
        break;
      case 'delete':
        this.handleMenuDelete();
        break;
      case 'clear':
        this.handleMenuClear();
        break;
      case 'copy_rating':
        this.handleMenuCopyRating();
        break;
      case 'copy':
        // this.handleMenuCopy();
        break;
      case 'paste':
        this.handleMenuPaste();
        break;
      case 'switch_occ_groups':
        this.handleMenuShowOccGroups();
        break;
      case 'flip_tables':
        this.handleMenuFlipTables(parameter);
        break;
    }
  }

  handleMenuSave = () => {
    let json = {
      inputAww: this.state.inputAww,
      aww: this.state.aww,
      isManualAww: this.state.isManualAww,
      awwArray: this.state.awwArray,
      ratings: this.state.ratings,
    };
    let body = JSON.stringify(json, null, 4);
    saveAsFile('pd-ratings.json', body);
  }

  handleMenuLoad = () => {
    this.refs.fileUploader.click();
  }

  onUploadFile = (e) => {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];

    let reader = new FileReader();
    reader.addEventListener('load', (e) => {
      // console.log(e.target.result);
      try {
        let hash = JSON.parse(e.target.result);

        let awwArray = hash.awwArray || [];
        awwArray.forEach(row => {
          row.startDate = new Date(row.startDate);
          row.endDate = new Date(row.endDate);
        });

        let ratings = hash.ratings;
        let ratingsStrings = [];
        for (let i=0; i<ratings.length; ++i) {
          if (ratings[i].ratingString != null)
            ratingsStrings.push(ratings[i].ratingString);
          else
            ratingsStrings.push(this.unknownRatingString);
        }
        this.tryToSetState({
          currentRating: 0,

          inputAww: hash.inputAww,
          aww: hash.aww,

          isManualAww: hash.isManualAww,
          awwArray: awwArray,

          ratings: ratings,
          ratingsStrings: ratingsStrings
        }, () => this.populate(true, true));
      }
      catch (e) {
        this.props.showError(e, 'Invalid file format');
        console.error(e);
      }
    });
    reader.readAsBinaryString(file);
  }

  handleMenuMail = () => {
    let aww = this.state.inputAww ? this.state.aww : undefined
    let s = getRatingsString(this.state);
    sendMail('', 'Permanent Disability Ratings', s);
  }

  handleMenuAdd = () => {
    let rating = { ... this.state.ratings[this.state.currentRating] };
    let ratings = [ ... this.state.ratings ];
    ratings.push(rating);

    let ratingString = this.state.ratingsStrings[this.state.currentRating];
    let ratingsStrings = [ ... this.state.ratingsStrings ];
    ratingsStrings.push(ratingString);

    this.combine({
      ratings: ratings,
      ratingsStrings: ratingsStrings,
    });
  }

  handleMenuDelete = () => {
    if (this.state.ratings.length <= 1)
      return;

    let currentRating = this.state.currentRating;

    let ratings = [ ... this.state.ratings ];
    ratings.splice(currentRating, 1);

    let ratingsStrings = [ ... this.state.ratingsStrings ];
    ratingsStrings.splice(currentRating, 1);

    let needsPopulate = false;
    if (currentRating >= ratings.length) {
      currentRating = ratings.length - 1;
      needsPopulate = true;
    }

    this.tryToSetState({
      currentRating: currentRating,
      ratings: ratings,
      ratingsStrings: ratingsStrings,
    }, () => {
      this.combine();
      if (needsPopulate)
        this.populate(false, false);
    });
  }

  handleMenuClear = () => {
    // Initial state has no body details / occupations arrays.
    this.tryToSetState(this.initialState, () => {
      this.fetchBodyDetails({ body: 0 }, this.calculate);
      this.fetchOccupations({ industry: 0 }, this.calculate);
    });
  }

  handleMenuCopyRating = () => {
    this.copiedRating = { ...this.state.ratings[this.state.currentRating] };
  }

  handleMenuCopy = () => {
    let s = getRatingsString(this.state);
    this.props.copyToClipboard(s);
  }

  handleMenuPdf = () => {
    this.props.setPdfData({ left: '', right: '', center: getRatingsString(this.state) });
  }

  handleMenuPaste = () => {
    if (this.copiedRating == undefined)
      return;

    let ratings = [ ... this.state.ratings ];

    // Set DOB and DOI that may had change from the copy time.
    this.copiedRating.birth = ratings[0].birth;
    this.copiedRating.injury = ratings[0].injury;
    ratings.push(this.copiedRating);

    let ratingsStrings = [ ... this.state.ratingsStrings ];
    ratingsStrings.push(this.copiedRating.ratingString);

    this.tryToSetState({
      ratings: ratings,
      ratingsStrings: ratingsStrings,
    }, () => this.populate(true, true));
  }

  handleMenuShowOccGroups = () => {
    // console.log("handleMenuShowOccGroups()");
    this.tryToSetState({
      isOccGroup: !this.state.isOccGroup,
    }, this.calculate);
  }

  handleMenuFlipTables = (flip) => {
    // this.flipTables = flip;
    this.blockFlip = !flip;
    // console.log(`handleMenuFlipTables(${flip})`);
    let lastTime = Date.now() + this.flipInterval;
    this.setState({
      bodyFlip: !flip,
      bodyDetailFlip: !flip,
      industryFlip: !flip,
      occupationFlip: !flip,
      occGroupFlip: !flip,
    }, () => {
      // console.log(`Setting lastAnimationTime to ${this.flipInterval}`);
      this.lastAnimationTime = lastTime;
    });
  }

  // --------------------- Calculations ---------------------
  // Return state + new ratings array, save in it selections of: wpi / apportionment / body part / occupation / etc.
  savePickerValues = (state) => {
    // console.log(this.state.ratings);
    // console.log(this.state.occGroup);
    let mergedState = { ...this.state, ...state };
    let result = { ratings: this.state.ratings, ...state };

    let occGroup = mergedState.isOccGroup ? mergedState.occGroups[mergedState.occGroup][0] : mergedState.occupations[mergedState.occupation][1];
    let dob = toDate(mergedState.dob);
    let doi = toDate(mergedState.doi);
    for (let i = 0; i < result.ratings.length; i++) {
      result.ratings[i]['isOccGroup'] = mergedState.isOccGroup;
      result.ratings[i]['birth'] = dob;
      result.ratings[i]['injury'] = doi;
      result.ratings[i]['occGroup'] = occGroup;
      // if (state.isOccGroup)
        result.ratings[i]['occGroupIndex'] = mergedState.occGroup;
      // else {
        result.ratings[i]['industryIndex'] = mergedState.industry;
        result.ratings[i]['occIndex'] = mergedState.occupation;

        result.ratings[i]['industryDescription'] = mergedState.industries[mergedState.industry];
        result.ratings[i]['occupationDescription'] = mergedState.occupations[mergedState.occupation][0];
      // }
    }
    let currentIndex = mergedState.currentRating;
    result.ratings[currentIndex]['wpi'] = mergedState.wpi;
    result.ratings[currentIndex]['apport'] = mergedState.apport;
    result.ratings[currentIndex]['bodyPart'] = mergedState.bodyDetails[mergedState.bodyDetail][1];
    result.ratings[currentIndex]['fec'] = mergedState.bodyDetails[mergedState.bodyDetail][2];
    result.ratings[currentIndex]['bodyIndex'] = mergedState.body;
    result.ratings[currentIndex]['bodyDetailIndex'] = mergedState.bodyDetail;

    result.ratings[currentIndex]['bodyPartDescription'] = mergedState.bodies[mergedState.body];
    result.ratings[currentIndex]['bodyDetailDescription'] = mergedState.bodyDetails[mergedState.bodyDetail][0];

    // console.log('savePickerValues():');
    // console.log(result);

    // console.log(state.ratings);
    return result;
  }

  // From ratings array to wpi / apportionment / body part / occupation / etc selections.
  populate = (full, calc) => {
    // console.log(`populate(${full}, ${calc}): currentRating = ${this.state.currentRating}`);

    let current = this.state.ratings[this.state.currentRating];
    let dob = new Date(current['birth']);
    let doi = new Date(current['injury']);
    let wpi = current['wpi'];
    let apport = current['apport'];
    let body = current['bodyIndex'];
    let bodyDetail = current['bodyDetailIndex'];
    let isOccGroup = current['isOccGroup'];
    let industry = current['industryIndex'];
    let occupation = current['occIndex'];
    let occGroupIndex = current['occGroupIndex'];
    if (isOccGroup == undefined)
      isOccGroup = false;
    if (industry == undefined)
      industry = 0;
    if (occupation == undefined)
      occupation = 0;
    if (occGroupIndex == undefined)
      occGroupIndex = 0;

    let occGroupString = this.state.occGroups[occGroupIndex];
    let occGroupSearchIndex = this.state.occGroupsSearch.indexOf(occGroupString);

    let promises = []; // Promises to exectute: fetch occupations / body details etc.
    let state = {
      dob: dob,
      doi: doi,
      occGroup: occGroupIndex,

      isOccGroup: isOccGroup,
      occGroupSearchIndex: occGroupSearchIndex,
      occGroupText: occGroupString[1],
    }; // State to set before resolving promises.

    let needChangeIndustry = full && !isOccGroup && (this.state.industry != industry);
    if (needChangeIndustry) {
      state['industry'] = industry;
      state['industryText'] = this.state.industries[industry];
    }

    let needChangeBody = this.state.body != body;
    if (needChangeBody) {
      state['body'] = body;
      state['bodyText'] = this.state.bodies[body];
    }

    // Set state to state, then execute promises.
    this.tryToSetState(state, () => {
      // console.log(`body = ${this.state.body}, industry = ${this.state.industry}`);
      if (needChangeIndustry)
        promises.push( this.fetchOccupationsPromise({ industry: industry }) );
      if (needChangeBody)
        promises.push( this.fetchBodyDetailsPromise({ body: body }) );

      Promise.all(promises).then( // Obtaining body details and occupations finished.
        (results) => {
          let newState = { wpi: wpi, apport: apport };
          let resultsState = results.reduce( (result, item) => { return { ...result, ...item }; }, {});
          // console.log(resultsState);

          let bodyDetails = resultsState.bodyDetails || this.state.bodyDetails;
          let occupations = resultsState.occupations || this.state.occupations;

          if (full && !isOccGroup) { // Occupation may change.
            if (needChangeIndustry) {
              let industryString = this.state.industries[industry];
              newState['industrySearchIndex'] = this.state.industriesSearch.indexOf(industryString);

              // Update occupations.
              newState = { ...newState, ...this.updateOccupations(resultsState) };
              newState['occupationSearchIndex'] = occupation;
            }
            else {
              let occupationString = this.state.occupations[occupation][0];
              let occupationSearchIndex = this.state.occupationsSearch.indexOf(occupationString);
              newState['occupationSearchIndex'] = occupationSearchIndex;
            }
            newState['occupation'] = occupation;
            newState['occupationText'] = occupations[occupation][0];
          }

          if (needChangeBody || this.state.bodyDetail != bodyDetail) {
            if (needChangeBody) {
              let bodyString = this.state.bodies[body];
              newState['bodySearchIndex'] = this.state.bodiesSearch.indexOf(bodyString);

              // Update body details.
              newState = { ...newState, ...this.updateBodyDetails(resultsState) };
              newState['bodyDetailSearchIndex'] = bodyDetail;
            }
            else {
              let bodyDetailString = this.state.bodyDetails[bodyDetail][0];
              let bodyDetailSearchIndex = this.state.bodyDetailsSearch.indexOf(bodyDetailString);
              newState['bodyDetailSearchIndex'] = bodyDetailSearchIndex;
            }

            newState['bodyDetail'] = bodyDetail;
            newState['bodyDetailText'] = bodyDetails[bodyDetail][0];
          }

          // console.log('newState:');
          // console.log(newState);
          this.tryToSetState(newState, () => {
            if (full || calc)
              this.calculate();
          });
        }, (error) => {
          console.error(error);
        }
      )
    })
  }

  // func takes resulting state.
  calculate = (state) => {
    // Check for data availability.
    let mergedState = {
      'bodyDetails': this.state.bodyDetails,
      'occupations': this.state.occupations,
      ...state
    };

    if (mergedState.bodyDetails.length === 0 || mergedState.occupations.length === 0 ||
        !isValidDate(this.state.dob) || !isValidDate(this.state.doi)) {
      console.log('calculate(), not ready, setting state:', state);
      this.tryToSetState(state); // Just save body details / occupations.
      return;
    }

    // console.log('calculate(), save picker values');
    let newState = this.savePickerValues(state);
    // console.log(newState);
    this.fetchRatings(newState, this.combine);
  }

  combine = (state) => {
    let warning = null;
    let ratings = state && state.ratings || this.state.ratings;
    for (let i = 0; i < ratings.length; ++i) {
      if (ratings[i].warning != null)
        warning = ratings[i].warning;
    }

    let combinedValue = warning ? 0 : combineRatings(ratings, this.state.isCombined);

    // console.log(`Combined value ${combinedValue}%, warning: ${warning}`);

    if (combinedValue == 100) {
      warning = 'Check out our Future Value Calculator from the left menu!';
      this.tryToSetState({
        combinedValue: combinedValue,
        warning: warning,
        amount: 0,
        ...state,
      });
    }
    else {
      let mergedState = {
        combinedValue: combinedValue,
        warning: warning,
        ...state,
      };
      this.fetchPermDisResult(mergedState, this.showResult);
    }
  }

  showResult = (state, result) => {
    // console.log(result);
    // permDisResult: { "aww":-1.0, "date":"1996-01-01T00:00:00.000+00:00", "disability":1, "minAWW":105.0, "maxAWW":210.0,
    //                  "minPDRate":70.0, "maxPDRate":140.0, "pdRate":140.0, "weeks":3.0, "amount":420.0}
    let pdRateText = result.pdRate <= result.minPDRate ? this.pdRateMinText :
                     result.pdRate >= result.maxPDRate ? this.pdRateMaxText : this.pdRateText;
    let newState = {
      pdRateText: pdRateText,
      pdRate: currencyFormatter.format(result.pdRate),
      amount: result.amount,
      ...state,
    };

    if ((!this.state.inputAww && !this.state.isManualAww) || currencyFormatter.parse(this.state.aww) <= 0.0)
      newState.aww = currencyFormatter.format(result.maxAWW);
    this.needCopy = true;
    this.tryToSetState(newState);
  }

  // --------------------- Rendering ---------------------
  render() {
    // console.log("PDRatings.render()");

    const { classes } = this.props;

    return (
      <div style={{height: '100%'}}>
      <input type="file" id="file" ref="fileUploader" style={{display: "none"}} onChange={this.onUploadFile}/>
      <MuiPickersUtilsProvider utils={ DateFnsUtils }>
      <Grid container spacing={1} className={classes.root}>

        {/* Date of Birth */}
        <Grid item xs={3} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
            <div className="picker">
              <DatePicker
                variant="outlined"
                label="Date of Birth"
                minDate={ this.minDOB }
                maxDate={ this.state.doi }
                value={ this.state.dob }
                onChange={ this.onDateOfBirthChanged }
                format={ 'MM/dd/yyyy' }
              />
            </div>
          </Paper>
        </Grid>

        {/* Date of Injury */}
        <Grid item xs={3} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
            <div className="picker">
              <DatePicker
                variant="outlined"
                label="Date of Injury"
                minDate={ this.minDOI }
                maxDate={ this.maxDOI }
                value={ this.state.doi }
                onChange={ this.onDateOfInjuryChanged }
                format={ 'MM/dd/yyyy' }
              />
            </div>
          </Paper>
        </Grid>

        {/* Whole Person Impairment */}
        <Grid item xs={3} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
            <FormControl>
              <FormLabel component="legend">Whole Person Impairment</FormLabel>
              <Select
                variant="outlined"
                value={ this.state.wpi }
                onChange={ e => this.onWpiIndexChanged(e.target.value) }
                input={<Input id="wpi" name="wpi" />}
                autoWidth
              >
                { this.itemsWPI }
              </Select>
            </FormControl>
          </Paper>
        </Grid>

        {/* Apportionment */}
        <Grid item xs={3} className={classes.alignCenter}>
          <Paper className={classes.wrapContent}>
            <FormControl>
              <FormLabel component="legend">Apportionment</FormLabel>
              <Select
                value={ this.state.apport }
                onChange={ e => this.onApportIndexChanged(e.target.value) }
                input={<Input id="apport" name="apport" />}
                autoWidth
              >
                { this.itemsApport }
              </Select>
            </FormControl>
          </Paper>
        </Grid>

        {/* Body part */}
        <Grid item xs={3} className={classes.alignCenter}>
          <ButtonFlip useFlip={this.flipTables} flipSpeed={this.flipInterval} isFlipped={this.state.bodyFlip} text={this.state.bodyText} onClick={this.onBodyFlip}>
            <Paper className={classes.wrapContent1}>
              {/* Search Bar Body part */}
              <FormControl className={classes.marginBottom}>
                <TextField
                  className={classes.searchField}
                  id="searchBodyDetail"
                  type="search"
                  margin="none"
                  label="Search body part"
                  value={ this.state.bodySearchString }
                  onChange={ this.onBodySearchChanged }
                />
              </FormControl>

              {/* List Body part */}
              <List subheader="Part of Body" onDoubleClick={this.onBodyFlip}>
                <div style={{ maxHeight: '17vh', overflow: 'auto' }}>
                  <SingleSelectionList items = { this.state.bodiesSearch }
                                       selectedIndex = { this.state.bodySearchIndex }
                                       onIndexChanged = { this.onBodyIndexChanged }
                                       onDoubleClick = { this.onBodyFlip } />
                </div>
              </List>
            </Paper>
          </ButtonFlip>
        </Grid>

        {/* Body Part Detail */}
        <Grid item xs={3} className={classes.alignCenter}>
          <ButtonFlip useFlip={this.flipTables} flipSpeed={this.flipInterval} isFlipped={this.state.bodyDetailFlip} text={this.state.bodyDetailText} onClick={this.onBodyDetailFlip}>
            <Paper className={classes.wrapContent1}>

              {/* Search Bar Body Detail */}
              <FormControl className={classes.marginBottom}>
                <TextField
                  className={classes.searchField}
                  id="searchBodyDetail"
                  type="search"
                  margin="none"
                  label="Search body part detail"
                  value={ this.state.bodyDetailSearchString }
                  onChange={ this.onBodyDetailSearchChanged }
                />
              </FormControl>
              {/* List Body detail */}
              <List subheader="Detailed Part of Body" onDoubleClick={this.onBodyDetailFlip}>
                <div style={{ maxHeight: '17vh', overflow: 'auto' }}>
                  <ItemArrayList name='Body Detail'
                                 items = { this.state.bodyDetailsSearch }
                                 titleIndex = { 0 }
                                 selectedIndex = { this.state.bodyDetailSearchIndex }
                                 onIndexChanged = { this.onBodyDetailIndexChanged } />
                </div>
              </List>
            </Paper>
          </ButtonFlip>
        </Grid>

        <Grid item xs={6} className={classes.alignCenter} >
          <ReactCardFlip isFlipped={this.state.isOccGroup} useOpacity={false}>
            <Grid container spacing={1} key="front" className={classes.noBackFace}>
              {/* Industry */}
              <Grid item xs={6} className={classes.alignCenter}>
                <ButtonFlip useFlip={this.flipTables} flipSpeed={this.flipInterval} isFlipped={this.state.industryFlip} text={this.state.industryText} onClick={this.onIndustryFlip}>
                  <Paper className={classes.wrapContent1}>
                    {/* Search Bar Industry */}
                    <FormControl className={classes.marginBottom}>
                      <TextField
                        className={classes.searchField}
                        id="searchInd"
                        type="search"
                        label="Search industry"
                        value={ this.state.industrySearchString }
                        onChange={ this.onIndustrySearchChanged }
                      >
                      </TextField>
                    </FormControl>
                    {/* List Industry */}
                    <List subheader="Occupational Industry" onDoubleClick={this.onIndustryFlip}>
                      <div style={{ maxHeight: '17vh', overflow: 'auto' }}>
                        <SingleSelectionList items = { this.state.industriesSearch }
                                             selectedIndex = { this.state.industrySearchIndex }
                                             onIndexChanged = { this.onIndustryIndexChanged } />
                      </div>
                    </List>
                  </Paper>
                </ButtonFlip>
              </Grid>

              {/* Occupation */}
              <Grid item xs={6} className={classes.alignCenter}>
                <ButtonFlip useFlip={this.flipTables} flipSpeed={this.flipInterval} isFlipped={this.state.occupationFlip} text={this.state.occupationText} onClick={this.onOccupationFlip}>
                  <Paper className={classes.wrapContent1}>
                    <FormControl className={classes.marginBottom}>
                      <TextField
                        className={classes.searchField}
                        id="searchOcc"
                        type="search"
                        label="Search occupation"
                        value={ this.state.occupationSearchString }
                        onChange={ this.onOccupationSearchChanged }
                      >
                      </TextField>
                    </FormControl>
                    {/* List Occupation */}
                    <List subheader="Occupations" onDoubleClick={this.onOccupationFlip}>
                      <div style={{ maxHeight: '17vh', overflow: 'auto' }}>
                        <ItemArrayList name='Occupations'
                                       items = { this.state.occupationsSearch }
                                       titleIndex = { 0 }
                                       selectedIndex = { this.state.occupationSearchIndex }
                                       onIndexChanged = { this.onOccupationIndexChanged } />
                      </div>
                    </List>
                  </Paper>
                </ButtonFlip>
              </Grid>
            </Grid>

            {/* Occupational Groups */}
            <div key="back" className={`${classes.noBackFace} ${classes.stretch}`}>
              <ButtonFlip useFlip={this.flipTables} flipSpeed={this.flipInterval} isFlipped={this.state.occGroupFlip} text={this.state.occGroupText} onClick={this.onOccGroupFlip}>
                <Paper className={classes.fullWidth}>
                  <FormControl className={classes.marginBottom}>
                    <TextField
                      className={classes.searchField}
                      id="searchOccGr"
                      type="search"
                      label="Search occupational groups"
                      value={ this.state.occGroupSearchString }
                      onChange={ this.onOccGroupsSearchChanged }
                    >
                    </TextField>
                  </FormControl>
                  {/* List Occupational Groups */}
                  <List subheader="Occupational Groups" onDoubleClick={this.onOccGroupFlip}>
                    <div style={{ maxHeight: '17vh', overflow: 'auto' }}>
                      <ItemArrayList name='Occupational Groups'
                                     items = { this.state.occGroupsSearch }
                                     titleIndex = { 1 }
                                     textIndex = { 2 }
                                     selectedIndex = { this.state.occGroupSearchIndex }
                                     onIndexChanged = { this.onOccGroupsIndexChanged } />
                    </div>
                  </List>
                </Paper>
              </ButtonFlip>
            </div>
          </ReactCardFlip>
        </Grid>

        {/* Ratings */}
        <Grid item xs={2} />
        <Grid item xs={8} className={classes.alignCenter}>
          <Paper className={classes.wrapContent1}>
            {/* List Ratings */}
            <List subheader="Ratings">
              <div style={{ maxHeight: '14vh', overflow: 'auto' }}>
                <SingleSelectionList items = { this.state.ratingsStrings }
                                     selectedIndex = { this.state.currentRating }
                                     onIndexChanged = { this.onRatingIndexChanged } />
              </div>
            </List>
          </Paper>
        </Grid>
        <Grid item xs={2} />

        <Grid item xs={3} className={classes.alignCenter}>
         {/* Input AWW */}
         <Paper className={classes.wrapContent}>
           <FormControl margin='none' >
             <React.Fragment>
               <List dense disablePadding>
                 <ListItem button dense key='inputAww' onClick={() => this.onInputAwwChanged(!this.state.inputAww)}>
                   <ListItemIcon>
                     <Checkbox
                       edge="start"
                       tabIndex={-1}
                       disableRipple
                       disabled={ this.state.isManualAww }
                       indeterminate={ this.state.isManualAww }
                       checked={ this.state.inputAww }
                       onChange={ (e) => this.onInputAwwChanged(e.target.checked) }
                       color="primary"
                       inputProps={{ 'aria-labelledby': 'AWW' }}
                     />
                   </ListItemIcon>
                   <ListItemText primary={ this.state.isManualAww ? 'Manual AWW' : 'Input AWW' } />
                   <ListItemSecondaryAction>
                     <Tooltip title="Manually input work periods and wages" aria-label="Add">
                       <IconButton
                         edge="end"
                         color={ this.state.awwArray.length > 0 ? "primary" : "inherit" }
                         aria-label="edit"
                         onClick={ this.onDialogOpen }>
                         <EditIcon />
                       </IconButton>
                     </Tooltip>
                   </ListItemSecondaryAction>
                 </ListItem>
               </List>
               <TextField
                 id="aww"
                 value={ this.state.aww }
                 onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
                 onChange={ (e) => this.setState({ aww: e.target.value, inputAww: true }) }
                 onFocus={ (e) => e.target.select() }
                 onBlur={ (e) => this.onAwwChanged(e.target.value) }
                 className={ classes.textField }
                 margin="dense"
                 InputProps={{
                   readOnly: this.state.isManualAww,
                 }}
               />
             </React.Fragment>
           </FormControl>
         </Paper>
        </Grid>

        <Grid item xs={3} className={classes.alignCenter}>
         {/* PD Rate */}
         <Paper className={classes.wrapContent}>
           <FormControl>
             <React.Fragment>
               <List dense disablePadding>
                 <ListItem button dense key='inputPdRate' onClick={() => this.onInputAwwChanged(!this.state.inputAww)}>
                   <ListItemIcon>
                     <Checkbox
                       edge="start"
                       tabIndex={-1}
                       disableRipple
                       disabled={ this.state.isManualAww }
                       indeterminate={ this.state.isManualAww }
                       checked={ this.state.inputAww }
                       onChange={ (e) => this.onInputAwwChanged(e.target.checked) }
                       color="primary"
                       inputProps={{ 'aria-labelledby': 'PDRate' }}
                     />
                   </ListItemIcon>
                   <ListItemText primary={ this.state.pdRateText } />
                 </ListItem>
               </List>
               <TextField
                 id="pdRate"
                 value={ this.state.pdRate }
                 onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
                 onChange={ (e) => this.setState({ pdRate: e.target.value, inputAww: true }) }
                 onFocus={ (e) => e.target.select() }
                 onBlur={ (e) => this.onPdRateChanged(e.target.value) }
                 className={ classes.textField }
                 margin="dense"
                 InputProps={{
                   readOnly: this.state.isManualAww,
                 }}
               />
             </React.Fragment>
           </FormControl>
         </Paper>
        </Grid>

        <Grid item xs={3} className={classes.alignCenter}>
          {/* Combined Value */}
          <Paper className={classes.wrapContent}>
           <FormControl>
             <React.Fragment>
               <List dense disablePadding>
                 <ListItem button dense key='inputCombinedValue' onClick={ (e) => this.onCombineChanged(!this.state.isCombined) }>
                   <ListItemIcon>
                     <Checkbox
                       edge="start"
                       tabIndex={-1}
                       disableRipple
                       checked={ this.state.isCombined }
                       onChange={ (e) => this.onCombineChanged(e.target.checked) }
                       color="primary"
                       inputProps={{ 'aria-labelledby': 'CombinedValue' }}
                     />
                   </ListItemIcon>
                  <ListItemText primary={ 'Combined Value' } />
                 </ListItem>
               </List>
               <TextField
                 id="combinedValue"
                 value={ this.state.combinedValue + '%' }
                 className={ classes.textField }
                 margin="dense"
                 InputProps={{
                   readOnly: true,
                 }}
               />
             </React.Fragment>
           </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={3} className={classes.alignCenter}>
          {/* Amount */}
          <Paper className={classes.wrapContent}>
            <TextField
              error={ this.state.warning != null }
              id="amount"
              label="Amount"
              variant="outlined"
              helperText={ this.state.warning }
              value={ currencyFormatter.format(this.state.amount) }
              className={ classes.textField }
              margin="none"
              InputLabelProps={{
                shrink: true,
                className: classes.inputLabel,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Paper>
        </Grid>
      </Grid>

      <TempDisabilityEarningsDialog
        classes={{
          paper: classes.withSpacing,
        }}
        id="dialog"
        keepMounted
        isOpen={ this.state.isDialogOpen }
        onValueChange={ this.onDialogChange }
        onClose={ this.onDialogClose }
        dateOfInjury={ this.state.doi }
        value={ this.state.awwDialogArray }
      />

      </MuiPickersUtilsProvider>
      </div>
    );
  }

};

export default withStyles(styles)(withErrorHandling(PDRatings));
